import { ArticleHeading5 } from '@cian/ui-kit';
import cx from 'classnames';
import * as React from 'react';

import * as styles from './SeoCrossLinks.css';
import { ICrossLinks } from '../../types/crossLinks';
import { capitalize } from '../../utils/string';

interface ISeoLinksProps {
  seoBlocks: ICrossLinks[];
}

const LocalMarkup = {
  ListItem: ({ children }: React.PropsWithChildren<{}>) => <li>{children}</li>,
  Link: ({ href, text }: { href: string; text: string }) => (
    <a className={styles['link']} href={href} title={text}>
      {capitalize(text)}
    </a>
  ),
  Button: ({ text, onClick }: { text: string; onClick: () => void }) => (
    <button onClick={onClick} className={styles['button']}>
      {capitalize(text)}
    </button>
  ),
  List: ({ className, children }: React.PropsWithChildren<{ className?: string }>) => (
    <ul className={cx(styles['list'], className)}>{children}</ul>
  ),
};

export function SeoCrossLinks({ seoBlocks }: ISeoLinksProps) {
  const [activeBlock, setActiveBlock] = React.useState<number | null>(null);

  return (
    <div className={styles['container']}>
      {activeBlock === null && (
        <div className={cx(styles['grid'], styles['grid_fit'])} data-name="SeoCrossLinksPreview">
          {seoBlocks.map((seoBlock, blockIndex) => (
            <div className={styles['row']} key={blockIndex}>
              <div className={styles['heading']}>
                <ArticleHeading5 as="h5">{capitalize(seoBlock.label)}</ArticleHeading5>
              </div>
              <LocalMarkup.List>
                {seoBlock.links.slice(0, 8).map((link, linkIndex) => (
                  <LocalMarkup.ListItem key={`${seoBlock.label}-${linkIndex}`}>
                    <LocalMarkup.Link href={link.url} text={link.anchor} />
                  </LocalMarkup.ListItem>
                ))}
                {seoBlock.links.length > 8 && (
                  <LocalMarkup.ListItem>
                    <LocalMarkup.Button text="Все" onClick={() => setActiveBlock(blockIndex)} />
                  </LocalMarkup.ListItem>
                )}
              </LocalMarkup.List>
            </div>
          ))}
        </div>
      )}

      {seoBlocks.map((seoBlock, blockIndex) => (
        <div
          className={cx(styles['block'], blockIndex === activeBlock && styles['block_visible'])}
          key={`${seoBlock.label}-full-${blockIndex}`}
          data-name="SeoCrossLinksFull"
        >
          <div className={styles['heading']}>
            <ArticleHeading5 as="h5">{capitalize(seoBlock.label)}</ArticleHeading5>
          </div>
          <LocalMarkup.List className={styles['grid']}>
            {seoBlock.links.map((link, linkIndex) => (
              <LocalMarkup.ListItem key={`${seoBlock.label}-${linkIndex}`}>
                <LocalMarkup.Link href={link.url} text={link.anchor} />
              </LocalMarkup.ListItem>
            ))}
          </LocalMarkup.List>
        </div>
      ))}

      {activeBlock !== null && (
        <div className={cx(styles['actions-row'], styles['grid'])}>
          {seoBlocks.map((seoBlock, blockIndex) => {
            if (blockIndex === activeBlock) {
              return null;
            }

            return (
              <LocalMarkup.Button
                onClick={() => setActiveBlock(blockIndex)}
                key={`${seoBlock.label}-btn-${blockIndex}`}
                text={capitalize(seoBlock.label)}
              />
            );
          })}
        </div>
      )}
    </div>
  );
}
